import React, { useState } from 'react';
import {createContribution, getVoucherByCode, useVoucher} from "../services/firestoreService";

const ContributionModal = ({
                               activeCases,
                               selectedCase,
                               setSelectedCase,
                               user,
                               onClose,
                               onContributionComplete
                           }) => {
    const [contributionType, setContributionType] = useState('single');
    const [selectedCases, setSelectedCases] = useState(new Set());
    const [voucherNumber, setVoucherNumber] = useState('');
    const [voucherError, setVoucherError] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('wallet');
    const [contributionAmount, setContributionAmount] = useState(50);
    const [isProcessing, setIsProcessing] = useState(false);

    // const processContribution = async () => {
    //     if (contributionType === 'multiple' && selectedCases.size === 0) {
    //         alert('Please select at least one case to contribute to.');
    //         return;
    //     }
    //
    //     if (paymentMethod === 'wallet' && calculateTotalAmount() > user.availableBalance) {
    //         alert('Insufficient wallet balance. Please use a voucher or reduce amount.');
    //         return;
    //     }
    //
    //     if (paymentMethod === 'voucher' && !voucherNumber) {
    //         setVoucherError('Voucher number is required');
    //         return;
    //     }
    //
    //     setIsProcessing(true);
    //
    //     try {
    //         const casesToContribute = contributionType === 'single'
    //             ? [selectedCase]
    //             : activeCases.filter(caseItem => selectedCases.has(caseItem.id));
    //
    //         // Validate voucher if used
    //         let voucher = null;
    //         if (paymentMethod === 'voucher') {
    //             voucher = await getVoucherByCode(voucherNumber);
    //             if (!voucher) {
    //                 setVoucherError('Voucher not found or invalid');
    //                 return;
    //             }
    //             if (voucher.status !== 'active') {
    //                 setVoucherError('Voucher has already been used or expired');
    //                 return;
    //             }
    //             if (voucher.amount < calculateTotalAmount()) {
    //                 setVoucherError('Voucher amount is insufficient for this contribution');
    //                 return;
    //             }
    //         }
    //
    //         // Process each contribution
    //         for (const caseItem of casesToContribute) {
    //             const contributionData = {
    //                 userId: user.uid,
    //                 userName: user.name,
    //                 caseId: caseItem.id,
    //                 caseMemberName: caseItem.memberName,
    //                 relationship: caseItem.relationship,
    //                 amount: contributionAmount,
    //                 paymentMethod,
    //                 voucherNumber: paymentMethod === 'voucher' ? voucherNumber : null,
    //                 status: 'completed'
    //             };
    //
    //             const contributionId = await createContribution(contributionData);
    //
    //             // Mark voucher as used if applicable
    //             if (paymentMethod === 'voucher' && voucher) {
    //                 await useVoucher(voucher.id, contributionData);
    //             }
    //         }
    //
    //         alert(`Thank you! Your ${contributionType} contribution has been processed successfully.`);
    //         onContributionComplete();
    //         onClose();
    //     } catch (error) {
    //         console.error('Error processing contribution:', error);
    //         alert('There was an error processing your contribution. Please try again.');
    //     } finally {
    //         setIsProcessing(false);
    //     }
    // };

    const presetAmounts = [25, 50, 100, 250, 500];

    // Generate sample voucher numbers (in real app, this would come from backend)
    const sampleVouchers = [
        'VCH-2024-001-ABC123',
        'VCH-2024-002-XYZ789',
        'VCH-2024-003-DEF456',
        'VCH-2024-004-GHI789',
        'VCH-2024-005-JKL012'
    ];

    const validateVoucher = (voucher) => {
        if (!voucher) {
            return 'Voucher number is required';
        }

        // Basic voucher format validation
        const voucherRegex = /^VCH-\d{4}-\d{3}-[A-Z0-9]{6}$/;
        if (!voucherRegex.test(voucher)) {
            return 'Invalid voucher format. Format: VCH-YYYY-NNN-XXXXXX';
        }

        // Check if voucher exists (in real app, this would be an API call)
        if (!sampleVouchers.includes(voucher)) {
            return 'Voucher not found or already used';
        }

        return '';
    };

    const toggleCaseSelection = (caseId) => {
        const newSelected = new Set(selectedCases);
        if (newSelected.has(caseId)) {
            newSelected.delete(caseId);
        } else {
            newSelected.add(caseId);
        }
        setSelectedCases(newSelected);
    };

    const calculateTotalAmount = () => {
        if (contributionType === 'single') {
            return contributionAmount;
        } else {
            return contributionAmount * selectedCases.size;
        }
    };

    const handleVoucherChange = (value) => {
        setVoucherNumber(value);
        if (voucherError) {
            setVoucherError('');
        }
    };

    const handleContribute = () => {
        if (paymentMethod === 'voucher') {
            const voucherValidationError = validateVoucher(voucherNumber);
            if (voucherValidationError) {
                setVoucherError(voucherValidationError);
                return;
            }
        }

        if (contributionType === 'multiple' && selectedCases.size === 0) {
            alert('Please select at least one case to contribute to.');
            return;
        }

        if (paymentMethod === 'wallet' && calculateTotalAmount() > user.availableBalance) {
            alert('Insufficient wallet balance. Please use a voucher or reduce amount.');
            return;
        }

        // onContribute(voucherNumber, paymentMethod);
    };

    const getSelectedCaseDetails = () => {
        return activeCases.filter(caseItem => selectedCases.has(caseItem.id));
    };

    const VoucherHelp = () => (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h5 className="font-medium text-blue-900 mb-2">💡 About Vouchers</h5>
            <ul className="text-sm text-blue-800 space-y-1">
                <li>• Vouchers can be purchased from authorized Chema agents</li>
                <li>• Format: VCH-YYYY-NNN-XXXXXX (e.g., VCH-2024-001-ABC123)</li>
                <li>• Each voucher can only be used once</li>
                <li>• Vouchers expire 12 months from purchase date</li>
            </ul>
        </div>
    );

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="px-6 py-4 border-b border-gray-200">
                    <div className="flex justify-between items-center">
                        <h3 className="text-lg font-semibold text-gray-900">Make a Contribution</h3>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-600 text-xl"
                        >
                            ×
                        </button>
                    </div>
                </div>

                <div className="p-6 space-y-6">
                    {/* Payment Method Selection */}
                    <div>
                        <h4 className="font-medium text-gray-900 mb-3">Payment Method</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <button
                                onClick={() => setPaymentMethod('voucher')}
                                className={`p-4 border-2 rounded-lg text-center transition-colors ${
                                    paymentMethod === 'voucher'
                                        ? 'border-primary-500 bg-primary-50 text-primary-700'
                                        : 'border-gray-200 hover:border-gray-300'
                                }`}
                            >
                                <div className="text-2xl mb-2">🎫</div>
                                <p className="font-medium">Use Voucher</p>
                                <p className="text-sm text-gray-600">Pre-paid voucher code</p>
                            </button>
                            <button
                                onClick={() => setPaymentMethod('wallet')}
                                className={`p-4 border-2 rounded-lg text-center transition-colors ${
                                    paymentMethod === 'wallet'
                                        ? 'border-primary-500 bg-primary-50 text-primary-700'
                                        : 'border-gray-200 hover:border-gray-300'
                                }`}
                            >
                                <div className="text-2xl mb-2">💰</div>
                                <p className="font-medium">Wallet Balance</p>
                                <p className="text-sm text-gray-600">Use available funds</p>
                            </button>
                        </div>
                    </div>

                    {/* Voucher Input */}
                    {paymentMethod === 'voucher' && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Voucher Number <span className="text-red-500">*</span>
                            </label>
                            <div className="space-y-3">
                                <input
                                    type="text"
                                    value={voucherNumber}
                                    onChange={(e) => handleVoucherChange(e.target.value)}
                                    placeholder="Enter voucher number (e.g., VCH-2024-001-ABC123)"
                                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
                                        voucherError ? 'border-red-500' : 'border-gray-300'
                                    }`}
                                />
                                {voucherError && (
                                    <p className="text-red-500 text-sm">{voucherError}</p>
                                )}

                                {/* Sample Vouchers for Testing */}
                                <div className="bg-gray-50 rounded-lg p-3">
                                    <p className="text-sm font-medium text-gray-700 mb-2">
                                        Test Vouchers (for demonstration):
                                    </p>
                                    <div className="grid grid-cols-1 gap-1">
                                        {sampleVouchers.map((voucher) => (
                                            <button
                                                key={voucher}
                                                type="button"
                                                onClick={() => handleVoucherChange(voucher)}
                                                className="text-xs text-left p-2 bg-white rounded border hover:bg-gray-50 transition-colors"
                                            >
                                                {voucher}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <VoucherHelp />
                            </div>
                        </div>
                    )}

                    {/* Contribution Type Selection */}
                    <div>
                        <h4 className="font-medium text-gray-900 mb-3">Contribution Type</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <button
                                onClick={() => setContributionType('single')}
                                className={`p-4 border-2 rounded-lg text-center transition-colors ${
                                    contributionType === 'single'
                                        ? 'border-primary-500 bg-primary-50 text-primary-700'
                                        : 'border-gray-200 hover:border-gray-300'
                                }`}
                            >
                                <div className="text-2xl mb-2">🎯</div>
                                <p className="font-medium">Single Case</p>
                                <p className="text-sm text-gray-600">Support one family</p>
                            </button>
                            <button
                                onClick={() => setContributionType('multiple')}
                                className={`p-4 border-2 rounded-lg text-center transition-colors ${
                                    contributionType === 'multiple'
                                        ? 'border-primary-500 bg-primary-50 text-primary-700'
                                        : 'border-gray-200 hover:border-gray-300'
                                }`}
                            >
                                <div className="text-2xl mb-2">🌟</div>
                                <p className="font-medium">Multiple Cases</p>
                                <p className="text-sm text-gray-600">Spread your support</p>
                            </button>
                        </div>
                    </div>

                    {/* Case Selection */}
                    <div>
                        <h4 className="font-medium text-gray-900 mb-3">
                            {contributionType === 'single' ? 'Select Case to Support' : 'Select Cases to Support'}
                        </h4>
                        <div className="space-y-3 max-h-60 overflow-y-auto">
                            {activeCases.map((caseItem) => (
                                <div
                                    key={caseItem.id}
                                    onClick={() => {
                                        if (contributionType === 'single') {
                                            setSelectedCase(caseItem);
                                        } else {
                                            toggleCaseSelection(caseItem.id);
                                        }
                                    }}
                                    className={`p-4 border-2 rounded-lg cursor-pointer transition-all ${
                                        (contributionType === 'single' && selectedCase?.id === caseItem.id) ||
                                        (contributionType === 'multiple' && selectedCases.has(caseItem.id))
                                            ? 'border-primary-500 bg-primary-50'
                                            : 'border-gray-200 hover:border-gray-300'
                                    }`}
                                >
                                    <div className="flex justify-between items-start">
                                        <div className="flex-1">
                                            <h5 className="font-semibold text-gray-900">{caseItem.member}</h5>
                                            <p className="text-sm text-gray-600">Loss of {caseItem.relationship}</p>
                                            <div className="flex items-center space-x-2 mt-2">
                                                <div className="w-full bg-gray-200 rounded-full h-2 flex-1">
                                                    <div
                                                        className="bg-primary-500 h-2 rounded-full"
                                                        style={{
                                                            width: `${(caseItem.amountRaised / caseItem.amountNeeded) * 100}%`
                                                        }}
                                                    ></div>
                                                </div>
                                                <span className="text-sm text-gray-600 whitespace-nowrap">
                          ${caseItem.amountRaised} / ${caseItem.amountNeeded}
                        </span>
                                            </div>
                                        </div>
                                        {contributionType === 'multiple' && (
                                            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ml-4 ${
                                                selectedCases.has(caseItem.id)
                                                    ? 'bg-primary-500 border-primary-500'
                                                    : 'border-gray-300'
                                            }`}>
                                                {selectedCases.has(caseItem.id) && (
                                                    <span className="text-white text-sm">✓</span>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Amount Selection */}
                    <div>
                        <h4 className="font-medium text-gray-900 mb-3">Contribution Amount</h4>
                        <div className="space-y-4">
                            <div className="grid grid-cols-5 gap-2">
                                {presetAmounts.map((amount) => (
                                    <button
                                        key={amount}
                                        onClick={() => setContributionAmount(amount)}
                                        className={`py-3 px-2 border rounded-lg text-sm font-medium transition-colors ${
                                            contributionAmount === amount
                                                ? 'border-primary-500 bg-primary-500 text-white'
                                                : 'border-gray-300 text-gray-700 hover:border-primary-300'
                                        }`}
                                    >
                                        ${amount}
                                    </button>
                                ))}
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Custom Amount
                                </label>
                                <div className="relative">
                                    <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">$</span>
                                    <input
                                        type="number"
                                        value={contributionAmount}
                                        onChange={(e) => setContributionAmount(Number(e.target.value))}
                                        className="w-full pl-8 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                                        min="1"
                                        max="1000"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Summary */}
                    <div className="bg-gray-50 rounded-lg p-4">
                        <h4 className="font-medium text-gray-900 mb-2">Contribution Summary</h4>
                        <div className="space-y-2 text-sm">
                            {contributionType === 'single' && selectedCase && (
                                <div className="flex justify-between">
                                    <span>Support for {selectedCase.member}:</span>
                                    <span>${contributionAmount}</span>
                                </div>
                            )}
                            {contributionType === 'multiple' && (
                                <>
                                    {getSelectedCaseDetails().map((caseItem) => (
                                        <div key={caseItem.id} className="flex justify-between">
                                            <span>{caseItem.member}:</span>
                                            <span>${contributionAmount}</span>
                                        </div>
                                    ))}
                                </>
                            )}
                            <div className="flex justify-between border-t pt-2 font-semibold">
                                <span>Total Amount:</span>
                                <span>${calculateTotalAmount()}</span>
                            </div>

                            {paymentMethod === 'voucher' && (
                                <div className="flex justify-between text-green-600">
                                    <span>Payment Method:</span>
                                    <span>Voucher ({voucherNumber})</span>
                                </div>
                            )}

                            {paymentMethod === 'wallet' && (
                                <div className={`flex justify-between ${
                                    calculateTotalAmount() > user.availableBalance ? 'text-red-600' : 'text-green-600'
                                }`}>
                                    <span>Your available balance:</span>
                                    <span>${user.availableBalance}</span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex space-x-3 pt-4">
                        <button
                            onClick={onClose}
                            disabled={isProcessing}
                            className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleContribute}
                            disabled={isProcessing ||
                                (contributionType === 'single' && !selectedCase) ||
                                (contributionType === 'multiple' && selectedCases.size === 0) ||
                                (paymentMethod === 'voucher' && !voucherNumber) ||
                                (paymentMethod === 'wallet' && calculateTotalAmount() > user.availableBalance)
                            }
                            className="flex-1 bg-primary-500 text-white px-4 py-3 rounded-lg hover:bg-primary-600 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center"
                        >
                            {isProcessing ? (
                                <>
                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                    Processing...
                                </>
                            ) : (
                                `Contribute $${calculateTotalAmount()}`
                            )}
                        </button>
                    </div>

                    {paymentMethod === 'wallet' && calculateTotalAmount() > user.availableBalance && (
                        <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                            <p className="text-red-700 text-sm text-center">
                                ❌ Insufficient balance. Please use a voucher or reduce your contribution amount.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ContributionModal;